import request from '@wearetla/tla-essentials-tools/utilities/request';

const branchServices = {
	getBranch: (branchSlug) => {
		return new Promise((resolve, reject) => {
			request.get(`client/branch/${branchSlug}`, {}, (payload, status, request) => {
				if (payload?.client_branch) {
					resolve(payload.client_branch);
				} else {
					reject(request?.data?.meta?.messages || 'Şube getirilirken bir hata ile karşılaşıldı.');
				}
			});
		});
	},
	getBranchMenuCategories: () => {
		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/menu-categories.json`,
				{},
				(payload, status, request) => {
					if (payload?.categories) {
						resolve(payload.categories);
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Menü kategorileri getirilirken bir hata ile karşılaşıldı.'
						);
					}
				},
				{ static: true }
			);
		});
	},
};

export default branchServices;
